import { useState } from "react";

interface Props {
  url: string;
  message?: string;
  onRetry: () => void;
  onPaste: (text: string) => void;
}

export function ErrorGame({ url, message, onRetry, onPaste }: Props) {
  const [text, setText] = useState("");
  return (
    <div className="gerr screen-enter">
      <div className="wrap gerr-inner">
        <button className="gbtn gerr-back" onClick={onRetry}>&larr; Try another URL</button>

        <div className="gerr-head pop">
          <span className="pill pill--red">Game over</span>
          <h2 className="gdisplay gerr-h2">Couldn't load {url || "that site"}.</h2>
          <p className="soft gerr-lead">
            {message || "It timed out, blocked us, or doesn't exist yet. No problem. Hand me the raw material and I'll judge that instead. Paste your homepage copy below."}
          </p>
        </div>

        <div className="gerr-grid pop" style={{ animationDelay: ".08s" }}>
          <div className="gcard gerr-card">
            <label className="glabel gerr-label">Paste your homepage copy</label>
            <textarea
              className="gfield gerr-textarea"
              rows={7}
              placeholder="Drop the headline, the subhead, the buttons. All of it. The more you give me, the harder I can hit."
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </div>
          <div className="gcard gerr-drop">
            <div className="gerr-drop-inner">
              <span className="gpixel gerr-drop-icon">[ IMG ]</span>
              <p className="soft gerr-drop-text">Screenshot upload is coming later. Paste your copy on the left for now.</p>
              <span className="glabel faint">PNG, JPG. Placeholder.</span>
            </div>
          </div>
        </div>

        <div className="gerr-actions pop" style={{ animationDelay: ".16s" }}>
          <button
            className="gbtn gbtn--primary gbtn--lg"
            disabled={text.trim().length < 12}
            onClick={() => onPaste(text.trim())}
          >
            Judge this instead <span aria-hidden="true">&rarr;</span>
          </button>
          <button className="gbtn gbtn--lg" onClick={onRetry}>Re-enter the URL</button>
        </div>
      </div>
    </div>
  );
}
